// extracted by mini-css-extract-plugin
export default {"Title":"Main_Title__38Fh4","Posts":"Main_Posts__eCX+F","createPost":"Main_createPost__q3MWF","Form":"Main_Form__mCRdY"};